// ActiveAdmin 4 entrypoint — bundled with esbuild to app/assets/builds/active_admin.js
// (served via Propshaft, loaded through ActiveAdmin's importmap pin "active_admin")

import '@activeadmin/activeadmin';

import $ from 'jquery';
window.$ = window.jQuery = $;

import TomSelect from 'tom-select';
window.TomSelect = TomSelect;

import { setupAutoInit, initSearchableSelects } from 'activeadmin-tom_select';
window.initSearchableSelects = initSearchableSelects;
setupAutoInit();

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

import { render } from 'preact';
import WorksComponent from './active_admin/components/works';

$(function () {
  $('#invoice_entity_id, #invoice_company_id').on('change', function () {
    var entity = $('#invoice_entity_id').val();
    if (!entity) {
      return;
    }
    var company = $('#invoice_company_id').val();
    if (!company) {
      return;
    }
    $.getJSON('/invoices/suggest', { company_id: company, entity_id: entity }, function (r) {
      if (r.contracts) {
        var $select = $('#invoice_contract_id');
        $select.html('<option></option>');
        r.contracts.forEach(function (v) {
          var $opt = $('<option>');
          $opt.attr('value', v.id);
          $opt.text(v.name);
          $select.append($opt);
        });
        if (r.contracts?.[0]) {
          $('#invoice_contract_id').val(r.contracts[0].id).trigger('change');
        }
      }
      if (r.invoice) {
        $('#invoice_goods_invoice').val(r.invoice.goods_invoice);
        $('#invoice_goods_act').val(r.invoice.goods_act);
        if (r.invoice.goods_sf) {
          $('#invoice_goods_sf').val(r.invoice.goods_sf);
        }
      }
    });
  });

  function runInvoiceCheck() {
    var $form = $('form#edit_invoice');
    if ($form.length == 0) {
      return;
    }

    var $items = $form.find('.has-many-container[data-has-many-association="invoice_items"] fieldset');
    var $boxes = $('#invoice_goods_invoice_input, #invoice_goods_act_input, #invoice_goods_sf_input');

    if ($items.length > 0) {
      $boxes.hide();
    } else {
      $boxes.show();
    }
  }

  // AA4 has_many is vanilla JS and fires no jQuery events — watch add clicks directly
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.has-many-add');
    if (add && add.closest('.has-many-container')?.dataset.hasManyAssociation === 'invoice_items') {
      setTimeout(runInvoiceCheck, 0);
    }
  });

  runInvoiceCheck();
  initIssuesTable();
});

$(function () {
  $('textarea.js-copy').click(async function () {
    var $t = $(this);
    $t.select();
    var val = this.innerHTML;
    await navigator.clipboard.writeText(this.value);
    this.innerHTML = 'Скопировано';
    setTimeout(() => {
      this.innerHTML = val;
      $t.select();
    }, 300);
  });
});

// Boolean toggle columns (extra/active_admin_toggle_bool.rb)
$(document).on('ajax:success', 'a.custom-toggle', function (event) {
  var $link = $(this);
  var data = event.detail?.[0];
  var attribute = new URLSearchParams(this.search).get('attribute');
  var active = data && attribute ? data[attribute] : !$link.hasClass('on');
  $link.toggleClass('on', !!active);
  $link.text(active ? 'да' : 'нет');
});

// Sidebar bool toggles rendered by CustomToggleBoolBuilder (extra/custom_toggle_bool_builder.rb)
$.ajaxSetup({
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content }
});

$(document).on('click', '.toggle-bool-switch', function () {
  var $el = $(this);
  var model = $el.data('model');
  var field = $el.data('field');
  var value = !($el.data('value') === true || $el.data('value') === 'true');
  var payload = {};
  payload[model] = {};
  payload[model][field] = value;
  $.ajax({
    url: $el.data('url'),
    method: 'POST',
    data: payload,
    success: function () {
      $el.data('value', value);
      $el.toggleClass('on', value);
    }
  });
});

document.documentElement.classList.add('active-admin-js-ready');

function initIssuesTable() {
  const $entity = $('#invoice_entity_id');
  const worksComponent = document.getElementById('works_component');

  $entity.on('change', function () {
    if (worksComponent) render(
      <WorksComponent entityIds={$entity.val()} />,
      worksComponent
    );
  });

  worksComponent && render(
    <WorksComponent entityIds={$entity.val()} />,
    worksComponent
  );
}
